import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline, pathTargets } from "./_helpers";
import type { Effect } from "../ir";

// Defocus-converge. Logo arrives from blurred-and-scattered: each path
// starts at a small jitter offset with high blur, then collapses to the
// mark. The "particles" effect is a hint to the runtime to overlay specks.
export const particleAssembly: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  const targets = pathTargets(logo);
  const n = Math.max(1, targets.length);
  const stagger = Math.min(0.10, 0.4 / n);

  return {
    ...base,
    effects: [
      { kind: "particles" as Effect, intensity: ir.particleDensity ?? 0.45 },
      { kind: "glow" as Effect, intensity: ir.glowIntensity ?? 0.25 },
      ...ir.effects,
    ].slice(0, 4),
    tracks: [
      {
        target: ROOT_TARGET,
        easing: "easeOutExpo",
        delay: 0,
        keyframes: [
          { t: 0,    opacity: 0, scale: 0.96, filter: "blur(10px)" },
          { t: 0.6,  opacity: 1, scale: 1.005, filter: "blur(0.8px)" },
          { t: 1,    opacity: 1, scale: 1,    filter: "blur(0px)" },
        ],
      },
      ...targets.map((sel, i) => {
        const start = i * stagger;
        const land = Math.min(start + 0.55, 0.95);
        const jx = ((i * 73) % 11 - 5) * 6;
        const jy = ((i * 97) % 7 - 3) * 6;
        return {
          target: sel,
          easing: "easeOutExpo" as const,
          delay: 0,
          keyframes: [
            { t: 0,       opacity: 0, scale: 0.7, x: jx, y: jy },
            { t: start,   opacity: 0, scale: 0.7, x: jx, y: jy },
            { t: land,    opacity: 1, scale: 1.02, x: jx * 0.05, y: jy * 0.05 },
            { t: 1,       opacity: 1, scale: 1,    x: 0,         y: 0 },
          ],
        };
      }),
    ],
  };
};
